import queryActionFactory from 'common/actions/queryActionFactory';
import DataV2 from 'common/DataV2';

import type { Idea } from 'common/api/endpoints/idea';

export { defaultState } from 'common/reducers/queryReducerFactory';

export type QueryParams = {
  ideaID: string;
};

const ideasActions = queryActionFactory<Idea, QueryParams>('idea', DataV2.queries.idea);

export const {
  // query helpers
  getQueryKey,

  // action creators
  invalidateQueries: invalidateIdea,
  reloadQuery: reloadIdea,
  removeItem,

  // action types
  RequestType,
  RequestMoreType,
  LoadedType,
  LoadedMoreType,
  ErrorType,
  InvalidateType,
  RemoveType,
} = ideasActions;

export const upsertIdea = (idea: Idea) => {
  const queryParams = {
    ideaID: idea._id,
  };
  const queryKey = getQueryKey(queryParams);
  return ideasActions.loadedAction(queryKey, queryParams, {
    cursor: null,
    items: [idea],
    hasNextPage: false,
  });
};

export const removeIdea = (idea: Idea) => {
  const queryParams = {
    ideaID: idea._id,
  };
  return removeItem(queryParams, idea);
};
